import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

export const GifItem = ({ gif }) => {
  return (
    <Fragment>
      <img src={gif.images.downsized_large.url} alt="GIF" />
    </Fragment>
  );
};

GifItem.propTypes = {
  gif: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(GifItem);
